import {
  AuthFlowType,
  ChallengeNameType,
  ChangePasswordCommand,
  ConfirmForgotPasswordCommand,
  ForgotPasswordCommand,
  GetUserCommand,
  GlobalSignOutCommand,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { AWS_APP_CLIENT_ID } from "../strings";
import { client } from "./cognito-client";

const loginRefresh = async ({ refreshToken }: { refreshToken: string }) =>
  client.send(
    new InitiateAuthCommand({
      AuthFlow: AuthFlowType.REFRESH_TOKEN_AUTH,
      AuthParameters: { REFRESH_TOKEN: refreshToken },
      ClientId: AWS_APP_CLIENT_ID
    })
  );

const loginUsernamePassword = async ({
  username,
  password,
}: {
  username: string;
  password: string;
}) =>
  client.send(
    new InitiateAuthCommand({
      AuthFlow: AuthFlowType.USER_PASSWORD_AUTH,
      AuthParameters: { USERNAME: username, PASSWORD: password },
      ClientId: AWS_APP_CLIENT_ID
    })
  );

const getUser = async ({ accessToken }: { accessToken: string }) =>
  client.send(
    new GetUserCommand({
      AccessToken: accessToken,
    })
  );

const challengeChangePassword = async ({
  session,
  username,
  proposedPassword,
}: {
  session: string;
  username: string;
  proposedPassword: string;
}) =>
  client.send(
    new RespondToAuthChallengeCommand({
      ChallengeName: ChallengeNameType.NEW_PASSWORD_REQUIRED,
      Session: session,
      ChallengeResponses: {
        NEW_PASSWORD: proposedPassword,
        USERNAME: username,
      },
      ClientId: AWS_APP_CLIENT_ID
    })
  );

const forgotPassword = async ({ username }: { username: string }) =>
  client.send(
    new ForgotPasswordCommand({
      Username: username,
      ClientId: AWS_APP_CLIENT_ID
    })
  );

const forgotPasswordConfirm = async ({
  username,
  password,
  confirmationCode,
}: {
  username: string;
  password: string;
  confirmationCode: string;
}) =>
  client.send(
    new ConfirmForgotPasswordCommand({
      Username: username,
      ConfirmationCode: confirmationCode,
      Password: password,
      ClientId: AWS_APP_CLIENT_ID
    })
  );

const changePassword = async ({
  accessToken,
  previousPassword,
  proposedPassword,
}: {
  accessToken: string;
  previousPassword: string;
  proposedPassword: string;
}) =>
  client.send(
    new ChangePasswordCommand({
      AccessToken: accessToken,
      PreviousPassword: previousPassword,
      ProposedPassword: proposedPassword,
    })
  );

const signOut = async ({ accessToken }: { accessToken: string }) =>
  client.send(new GlobalSignOutCommand({ AccessToken: accessToken }));

export const commands = {
  loginRefresh,
  loginUsernamePassword,
  getUser,
  challengeChangePassword,
  forgotPassword,
  forgotPasswordConfirm,
  changePassword,
  signOut,
};
